import * as RPopover from '@radix-ui/react-popover'
import type { ReactNode } from 'react'
import { cn } from '../lib/cn'

export interface PopoverProps {
  trigger: ReactNode
  children: ReactNode
  /** Accessible name for the popover surface itself. */
  label: string
  side?: 'top' | 'right' | 'bottom' | 'left'
  align?: 'start' | 'center' | 'end'
  open?: boolean
  onOpenChange?: (open: boolean) => void
  className?: string
}

/**
 * For content that must be keyboard-reachable and may contain controls —
 * unlike `<Tooltip>`. Used by the estimate cost breakdown, filter panels, and
 * the citation preview.
 */
export function Popover({
  trigger,
  children,
  label,
  side = 'bottom',
  align = 'start',
  open,
  onOpenChange,
  className,
}: PopoverProps) {
  return (
    <RPopover.Root open={open} onOpenChange={onOpenChange}>
      <RPopover.Trigger asChild>{trigger}</RPopover.Trigger>
      <RPopover.Portal>
        <RPopover.Content
          side={side}
          align={align}
          sideOffset={6}
          collisionPadding={8}
          aria-label={label}
          className={cn(
            'z-modal max-w-sm rounded-md border border-border-subtle bg-surface-overlay p-4 shadow-lg',
            'data-[state=open]:animate-fade-in',
            className,
          )}
        >
          {children}
          <RPopover.Arrow className="fill-[--surface-overlay]" />
        </RPopover.Content>
      </RPopover.Portal>
    </RPopover.Root>
  )
}
